import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c579b492"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "userProfile",
  class: "page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title ms-3" }, "User", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mb-4" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = {
  key: 0,
  class: "card-body"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Profile", -1))
const _hoisted_8 = { class: "row mt-4" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select your gender", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "FEMALE" }, "Female", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "MALE" }, "Male", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "DIVERSE" }, "Diverse", -1))
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "col-md-6 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.profile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control mb-3",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profile.gender) = $event))
                    }, _hoisted_14, 512), [
                      [_vModelSelect, _ctx.profile.gender]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      placeholder: "First Name",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.firstName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.profile.firstName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      placeholder: "First Name",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile.lastName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.profile.lastName]
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary float-end",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)))
                }, "Save")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}